import { computed } from "nanostores";
import { requestGet } from "../utils/request.ts";
import { $sessionVersion, getSessionVersion, refreshUserInfo } from "./user_info.ts";
import { createRefreshResource } from "../utils/refresh_resource.ts";

export interface CameraInfo {
    camera_id: number;
    camera_name: string;
    group_name?: string;
    camera_pinned_time: number;
    photo_count: number;
    status: Record<string, string>;
    last_photo_time: number;
    last_photo_id: number;
    capture_interval?: string;
    subscription_expire?: number;
    oss_type?: "paid" | "own" | "none";
    [key: string]: any; // Allow index access for DataGrid
}

const CAMERA_INFO_FIELDS = [
    "camera_name",
    "group_name",
    "camera_pinned_time",
    "photo_count",
    "status",
    "last_photo_time",
    "last_photo_id",
    "capture_interval",
    "subscription_expire",
    "oss_type",
];

export const cameraResource = createRefreshResource(async signal => {
    const resp = await requestGet<{ cameras: CameraInfo[] }>("/v2/camera", {
        fields: CAMERA_INFO_FIELDS.join(","),
    }, signal);
    return resp.cameras;
}, [] as CameraInfo[], getSessionVersion);
export const $cameraList = computed(cameraResource.$state, state => state.data);
export const $cameraListLoaded = computed(cameraResource.$state, state => state.loaded);
export const updateCameraInfo = cameraResource.refresh;
export const invalidateCameraInfo = cameraResource.invalidate;
export const refreshCameraPage = async () => {
    await refreshUserInfo();
    await updateCameraInfo();
};

export const getCameraInfoById = (cameraId: number) => {
    for (const info of $cameraList.get()) {
        if (info.camera_id === cameraId) return info;
    }
    return undefined;
};

$sessionVersion.listen(() => cameraResource.reset());
